import React, { useState } from "react";
import { LogoCenter } from "../../component/LogoCenter";
import arrowNext from "../../images/arrowNext.svg";
import { Link } from "react-router-dom";

const SignUpTraining: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptionDropdown, setSelectedOptionDropdown] = useState<string>("Sport");
  const [selectedOptionRadio, setSelectedOptionRadio] = useState<string>("");

  const dropdownOptions = ["Sport", "Fitness", "Yoga"]; // Dropdown options

  const handleOptionClick = (option: string) => {
    setSelectedOptionDropdown(option);
    setIsOpen(false);
  };

  return (
    <div className={`p-[20px] bg-black h-dvh overflow-hidden `}>
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center  overflow-y-auto">
        <LogoCenter />
        <div className="flex flex-col gap-[50px] w-full">
          <div className="flex flex-col justify-center gap-[15px]">
            <h1 className="text-white text-[40px] leading-[95%] uppercase font-light">
              training
              <br />
              preference
            </h1>
            <form action="" className="flex flex-col gap-[15px]">
              <div className="flex gap-[30px] w-full max-w-[315px] mx-auto justify-center py-6">
                <label className="flex items-center flex-col space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="training"
                    value="on-site"
                    checked={selectedOptionRadio === "on-site"}
                    onChange={() => setSelectedOptionRadio("on-site")}
                    className="hidden"
                  />
                  <span
                    className={`w-[50px] h-[50px] rounded-full ${
                      selectedOptionRadio === "on-site" ? "bg-white" : "bg-[#171717]"
                    }`}
                  ></span>
                  <span className="text-white font-normal mt-4 text-sm">ON-SITE TRAINING</span>
                </label>
                <label className="flex items-center flex-col space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="training"
                    value="online"
                    checked={selectedOptionRadio === "online"}
                    onChange={() => setSelectedOptionRadio("online")}
                    className="hidden"
                  />
                  <span
                    className={`w-[50px] h-[50px] rounded-full ${
                      selectedOptionRadio === "online" ? "bg-white" : "bg-[#171717]"
                    }`}
                  ></span>
                  <span className="text-white font-normal mt-4 text-sm">ONLINE TRAINING</span>
                </label>
              </div>

              {/* Dropdown */}
              <div className="relative">
                <div
                  onClick={() => setIsOpen(!isOpen)}
                  className="bg-transparent text-white text-lg font-normal border border-white rounded-[45px] p-4 flex items-center justify-between cursor-pointer"
                >
                  {selectedOptionDropdown}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`transform transition-transform ${
                      isOpen ? "rotate-180" : "rotate-0"
                    }`}
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                  >
                    <path
                      d="M1 0.999999L7 7L13 1"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                {isOpen && (
                  <div className="absolute bg-black border border-white rounded-md mt-2 w-full z-10">
                    {dropdownOptions.map((option) => (
                      <div
                        key={option}
                        onClick={() => handleOptionClick(option)}
                        className={`px-4 py-2 cursor-pointer text-lg font-normal text-white hover:bg-white/50`}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </form>
          </div>
          <Link
            to="/signupprofile1"
            className="bg-white size-[70px] rounded-full flex justify-center items-center hover:bg-white/50 transition-all duration-300 ml-auto"
          >
            <img src={arrowNext} alt="arrow" className="object-contain" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignUpTraining;
